import React, { useEffect, useState } from 'react';
import './index.css';
import { useSelector } from 'react-redux';
import { PermissionsList } from '../../models/Permissions';
import { useTranslation } from 'react-i18next';
import { Helper } from '../../utils/Helper/HelperUtil';

const RepairJourney: React.FC = () => {
    const { t } = useTranslation();
    const [showJourneyHeader, setShowJourneyHeader] = useState(false);
    const getPermissionsData = useSelector((state: any) => state?.userChoicesReducer?.userProfilePermissions);
    const customerData = useSelector((state: any) => state?.userChoicesReducer?.customersData);
    const assetDataDetails = useSelector((state: any) => state?.addresses?.assetData);
    const previousPage = useSelector((state:any)=> state?.financialReferralReducer?.previousPageName);
    const address = customerData?.addresses?.postalAddresses?.[0];
    const propertyAddTemp = assetDataDetails?.addresses?.postalAddresses[0];

    let custfullAddress = "-";
    if (address) {
        const addressLine3Comma = address?.addressLine3 ? "," : "";
        custfullAddress = `${address?.addressLine1}, ${address?.addressLine2 ?? ""}, ${address?.addressLine3 ?? ""} ${addressLine3Comma} ${address?.postcode ?? ""}`;
    }

    let propertyAddress = "-";
    if (propertyAddTemp?.formattedAddress) {
        propertyAddress = propertyAddTemp.formattedAddress;
    } else if (propertyAddTemp) {
        propertyAddress = `${propertyAddTemp.addressLine1}, ${propertyAddTemp.addressLine2 ?? ""}, ${propertyAddTemp.addressLine3 ?? ""} ${propertyAddTemp.addressLine3 ? "," : ""} ${propertyAddTemp.addressLine4 ?? ""} ${propertyAddTemp.addressLine4 ? "," : ""} ${propertyAddTemp.addressLine5 ?? ""} ${propertyAddTemp.addressLine5 ? "," : ""} ${propertyAddTemp.postcode ?? ""}`;
    }

    let findJointName = "-";
    if (customerData?.tenanciesSummaries?.[0]?.tenancySummary?.cdmName) {
        findJointName = customerData.tenanciesSummaries[0].tenancySummary.cdmName;
    }
    
    useEffect(() => {
        const hasAllPermissions = Helper.doesHavePermission(getPermissionsData, PermissionsList.workorder_review_triage_repair) &&
            Helper.doesHavePermission(getPermissionsData, PermissionsList.workorder_no_triage_forheatingandhotwaterrepairs) &&
            Helper.doesHavePermission(getPermissionsData, PermissionsList.workorder_override_duplicate_repairs) &&
            Helper.doesHavePermission(getPermissionsData, PermissionsList.workorder_choose_priority_of_repair);

        setShowJourneyHeader(hasAllPermissions);
    }, [getPermissionsData]);

    return (
        <>
        {showJourneyHeader && window.screen.width > 820 &&
         <div className='journeyHeaderTitle mt-2'>
            {previousPage === 'Property' && (
            <>
            <span className='block-wid mt-2'><strong>{assetDataDetails?.assetType}</strong></span>
            <span className='w-prprty'><strong>{t('asset_uprn')}</strong><br />{assetDataDetails?.uprn ?? "-"}</span>
            <span className='w-prprty'><strong>{t('RepairJourney_ResidentName')}</strong><br />{findJointName?.includes('&') ? findJointName?.split('&')[0].trim() : findJointName ?? "-"}</span>
            {findJointName?.includes('&') && <span className='w-jointt-name'><strong>{t('RepairJourney_JointResidentName')}<br /></strong>{findJointName?.includes('&') ? findJointName.split('&')[1].trim() : "-"}</span>}
            <span className=''><strong>{t('address_txt')}</strong><br />{propertyAddress ?? "-"}</span>
            </>)}
            
            {previousPage === 'customer' && <>
            <span className='block-wid mt-3'><strong>{`${customerData?.person?.name?.givenName} ${customerData?.person?.name?.surname ?? ""}`}</strong></span>
            <span className='w-prprty mb-2'><strong>{t('Home')}</strong><br />{customerData?.addresses?.telecomsAddresses[0]?.number ?? "-"}</span>
            <span className='w-prprty mb-2'><strong>{t('Mobile')}</strong><br />{customerData?.addresses?.telecomsAddresses[1]?.number ?? "-"}</span>
            <span className='mb-2'><strong>{t('address_txt')}<br /></strong>{custfullAddress ?? "-"}</span>
            </>}
            {(previousPage === "Divided Block" || previousPage === "Block" || previousPage === "Estate") && (
                <>
                <span className='block-wid mt-2'><strong>{assetDataDetails?.assetType}</strong></span>
                <span className='w-prprty'><strong>{t('asset_uprn')}</strong><br />{assetDataDetails?.uprn ?? "-"}</span>
                <span className=''><strong>{t('address_txt')}</strong><br />{propertyAddress ?? "-"}</span>
                </>
            )}
            
        </div>}
        </>
    );
};

export default RepairJourney;